class Aiki {
	static init() {
		Aiki.initLeaflet();
	}
	static initLeaflet() {
		const leafletCss = document.createElement(`link`);
		leafletCss.setAttribute(`rel`,`stylesheet`);
		leafletCss.setAttribute(`href`,`https://unpkg.com/leaflet@1.9.4/dist/leaflet.css`);
		leafletCss.setAttribute(`integrity`, `sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=`);
		leafletCss.setAttribute(`crossorigin`, ``);

		const cssPromise = new Promise( (resolve,_)=>{
			leafletCss.addEventListener(`load`,()=>{
				resolve(leafletCss);
			});
			document.head.appendChild(leafletCss);			
		});

		const leafletJs = document.createElement(`script`);
		leafletJs.setAttribute(`src`,"https://unpkg.com/leaflet@1.9.4/dist/leaflet.js");
		leafletJs.setAttribute(`integrity`,"sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=");
		leafletJs.setAttribute(`crossorigin`,``);

		const jsPromise = new Promise( (resolve,_) => {
			leafletJs.addEventListener(`load`,()=>{
				resolve(leafletJs);				
			});
			document.head.appendChild(leafletJs);
		});

		Promise.all( [ cssPromise, jsPromise ] ).then( ()=>{
			console.log(`Promise.all leaflets resolved, L = `, L);
			const tiles = L.tileLayer('//tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
					subdomains: 'abcd',
					minZoom: 0,
					maxZoom: 20
				});
			const map = L.map('map').setView([-33.919708,18.417388], 13);

			tiles.addTo(map);
			L.marker([-33.919708,18.417388]).addTo(map);
		});

	}
}

document.addEventListener('DOMContentLoaded', ()=>Aiki.init());
